###
# Платеж
###
App.Payment = DS.Model.extend
  payment_type      : DS.attr 'string'
  sum               : DS.attr 'number'
  payer_contact     : DS.attr 'string'
  payment_submitted : DS.attr 'boolean'
  payment_success   : DS.attr 'boolean'
  payment_type_text : DS.attr 'string'
  created_at        : DS.attr 'date'
  received_date     : DS.attr 'date'
  secure_id         : DS.attr 'string'

  organization      : DS.belongsTo 'organization', async: true
  order             : DS.belongsTo 'order', async: true
